import { Directive, ElementRef, HostListener, Input, OnInit } from "@angular/core";
import { NG_VALIDATORS } from "@angular/forms";

@Directive({
    selector: '[appFormatDirective]',
    standalone: false
})
export class FormatDirective implements OnInit{
  @Input() appFormatDirective: string;
  private regex: RegExp;

  private specialKeys = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
  ];

  // TODO: Update regex to remove this special characters
  private invalidKeys = ["`", "^", "_", "]", "[", "\\"];

  constructor(private el: ElementRef) {
  }
  
  ngOnInit() {
    this.regex = new RegExp(this.appFormatDirective.valueOf());
  }

  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    if( this.el.nativeElement.selectionStart 
      != this.el.nativeElement.selectionEnd) {
      this.el.nativeElement.value = null;
    } 

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;

    this.el.nativeElement.setSelectionRange(position, position, "none");

    const next: string =
      current.slice(0, position) + event.key + current.slice(position);

    if (
      (next && !String(next).match(this.regex)) ||
      this.invalidKeys.indexOf(event.key) !== -1
    ) {
      event.preventDefault();
    }
  }
}
